module.exports = __webpack_public_path__ + "img/DJI_0204.3e048e81.jpg";